const sfs_fixed = {
    init: () => {
  
  
        if ($('.shopify-section .sfs-fixed')[0]) {

            $('.shopify-section .sfs-fixed').each(function() {
                let section_id = $(this).data('section-id');
                let parent = `.sfs-fixed[data-section-id="${section_id}"]`;

                function randomRotate($photoEl)
                {
                    let randMin = -10.00,
                        randMax = 10.00,
                        degrees = (Math.random() * (randMax - randMin) + randMin).toFixed(4),
                        dist    = degrees * 2;
                    $photoEl.css('transform', `rotate(${degrees}deg) translateY(${dist}px) translateX(${dist}px)`);
                }

                $(`${parent} .sfs-fixed__images .photo-stack__photo`).each(function() {
                    randomRotate($(this));
                });

            });
                
        }
  
  
    }
  };
  export default sfs_fixed;